import {
  createCategory,
  createProduct,
  deleteCategory,
  deleteProduct,
  editProduct,
  getCategories,
  getProduct,
  getProducts,
  getProductsByCategory,
  getProductsSearch,
} from "./asyncThunks";

export const getProductsBuilder = (builder) => {
  builder.addCase(getProducts.pending, (state) => {
    state.products.loading = true;
  });
  builder.addCase(getProducts.fulfilled, (state, { payload }) => {
    const { data, total, perPage, page, maxReached } = payload;
    if (page === 1) {
      state.products.data = data;
    } else {
      state.products.data = [...state.products.data, ...data];
    }
    state.products.total = total;
    state.products.page = page;
    state.products.perPage = perPage;
    state.products.maxReached = maxReached;
    state.products.loading = false;
  });
  builder.addCase(getProducts.rejected, (state, action) => {
    state.products.loading = false;
    state.products.error = action.error.message;
  });
};

export const getProductsSearchBuilder = (builder) => {
  builder.addCase(getProductsSearch.pending, (state) => {
    state.searchProducts.loading = true;
  });
  builder.addCase(getProductsSearch.fulfilled, (state, { payload }) => {
    const { data, total, perPage, page, maxReached } = payload;
    if (page === 1) {
      state.searchProducts.data = data;
    } else {
      state.searchProducts.data = [...state.products.data, ...data];
    }
    state.searchProducts.total = total;
    state.searchProducts.page = page;
    state.searchProducts.perPage = perPage;
    state.searchProducts.maxReached = maxReached;
    state.searchProducts.loading = false;
  });
  builder.addCase(getProductsSearch.rejected, (state, action) => {
    state.searchProducts.loading = false;
    state.searchProducts.error = action.error.message;
  });
};

export const getProductBuilder = (builder) => {
  builder.addCase(getProduct.pending, (state) => {
    state.selectedProduct.loading = true;
  });
  builder.addCase(getProduct.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.selectedProduct.data = data;
    state.selectedProduct.loading = false;
  });
  builder.addCase(getProduct.rejected, (state, action) => {
    state.selectedProduct.loading = false;
    state.selectedProduct.error = action.error.message;
  });
};

export const getProductsByCategoryBuilder = (builder) => {
  builder.addCase(getProductsByCategory.fulfilled, (state, { payload }) => {
    const { data, categoryName } = payload;

    state.products.productsByCategory = {
      ...state.products.productsByCategory,
      [categoryName]: {
        data,
      },
    };
  });
};

export const getCategoriesBuilder = (builder) => {
  builder.addCase(getCategories.pending, (state) => {
    state.categories.loading = true;
  });
  builder.addCase(getCategories.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.categories.data = data;
    state.categories.loading = false;
  });
  builder.addCase(getCategories.rejected, (state, action) => {
    state.categories.loading = false;
    state.categories.error = action.error.message;
  });
};

export const createCategoryBuilder = (builder) => {
  builder.addCase(createCategory.pending, (state) => {
    state.categories.createLoading = true;
  });
  builder.addCase(createCategory.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.categories.data = [...state.categories.data, data];
    state.categories.createLoading = false;
  });
  builder.addCase(createCategory.rejected, (state, action) => {
    state.categories.createLoading = false;
    state.categories.error = action.error.message;
  });
};

export const deleteCategoryBuilder = (builder) => {
  builder.addCase(deleteCategory.pending, (state) => {
    state.categories.deleteLoading = true;
  });
  builder.addCase(deleteCategory.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.categories.data = state.categories.data.filter(
      (ctg) => ctg.id !== data.id
    );
    state.categories.deleteLoading = false;
  });
  builder.addCase(deleteCategory.rejected, (state, action) => {
    state.categories.deleteLoading = false;
    state.categories.error = action.error.message;
  });
};

export const createProductBuilder = (builder) => {
  builder.addCase(createProduct.pending, (state) => {
    state.products.createLoading = true;
  });
  builder.addCase(createProduct.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.products.data = [...state.products.data, data];
    state.products.createLoading = false;
  });
  builder.addCase(createProduct.rejected, (state, action) => {
    state.products.createLoading = false;
    state.products.error = action.error.message;
  });
};

export const editProductBuilder = (builder) => {
  builder.addCase(editProduct.pending, (state) => {
    state.products.editLoading = true;
  });
  builder.addCase(editProduct.fulfilled, (state, { payload }) => {
    const { data } = payload;

    const index = state.products.data.findIndex((p) => p.id === data.id);
    if (index !== -1) {
      state.products.data[index] = data;
    }
    state.products.editLoading = false;
  });
  builder.addCase(editProduct.rejected, (state, action) => {
    state.products.editLoading = false;
    state.products.error = action.error.message;
  });
};

export const deleteProductBuilder = (builder) => {
  builder.addCase(deleteProduct.pending, (state) => {
    state.products.deleteLoading = true;
  });
  builder.addCase(deleteProduct.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.products.data = state.products.data.filter(
      (product) => product.id !== data.id
    );
    state.products.deleteLoading = false;
  });
  builder.addCase(deleteProduct.rejected, (state, action) => {
    state.products.deleteLoading = false;
    state.products.error = action.error.message;
  });
};
